















































































































































































































































































































































































































































import './PasswordComponent.less';
import { PasswordComponent } from './PasswordComponent';
export default PasswordComponent;
